<template>
  <div class="total-cost">
    <img loading="lazy" sizes="100%, 100%" :src="coinSrc" alt="Total cost"
         title="Total cost">
    <span class="coin-total">{{formatPrice(tc)}}</span>
  </div>
</template>

<script>
  export default {
    name: "ItemCost",
    props: {
      price: {
        type: Number,
        required: true,
      }
    },
    data() {
      return {
        itemPrices: {},
      }
    },
    computed: {
      coinSrc: function () {
        if (this.tc >= 10000)
          return "/static/images/icons/coins/10000.png";

        if (this.tc >= 1000)
          return "/static/images/icons/coins/1000.png";

        if (this.tc >= 250)
          return "/static/images/icons/coins/250.png";

        if (this.tc >= 100)
          return "/static/images/icons/coins/100.png";

        if (this.tc >= 25)
          return "/static/images/icons/coins/25.png";

        if (this.tc >= 5)
          return "/static/images/icons/coins/5.png";

        if (this.tc >= 4)
          return "/static/images/icons/coins/4.png";

        if (this.tc >= 3)
          return "/static/images/icons/coins/3.png";

        if (this.tc >= 2)
          return "/static/images/icons/coins/2.png";

        return "/static/images/icons/coins/1.png"
      },
      tc: function () {
        return this.price;
      },
    },
    methods: {
      formatPrice(value) {
        let formatter = new Intl.NumberFormat('en-US', {
          style: 'decimal',
          minimumFractionDigits: 0
        });
        return formatter.format(value);
      }
    },
    mounted() {
    }
  }
</script>

<style scoped>
  .coin-total {
    font-family: 'RuneScape UF', sans-serif;
    text-shadow: 0.1rem 0.1rem black;
    /*font-size: 1.4rem;*/
    letter-spacing: 0.1rem;
    color: #F5FC00;
  }
</style>



// WEBPACK FOOTER //
// src/components/margins/ItemCost.vue